import { Drawing, Pixels } from "./index";
import { all } from "./select";
import { floodPath } from "./path";

export function flip(
  drawing: Drawing,
  idxs = all,
  isNewStroke = true
): Drawing {
  idxs = idxs.filter((idx) => idx >= 0 || idx < Drawing.side * Drawing.side);
  return idxs.length === 0
    ? drawing
    : new Drawing({
        id: drawing.id,
        pixels: nextPixelState(drawing, idxs),
        strokes: isNewStroke
          ? [...drawing.strokes.slice(0, drawing.currStroke + 1), idxs]
          : [
              ...drawing.strokes.slice(0, drawing.currStroke),
              [...drawing.strokes[drawing.currStroke], ...idxs],
            ],
        currStroke: isNewStroke ? drawing.currStroke + 1 : drawing.currStroke,
      });
}

export function clear(
  drawing: Drawing,
  idxs = all,
  isNewStroke = true
): Drawing {
  idxs = idxs.filter((idx) => drawing.pixels[idx]);
  return flip(drawing, idxs, isNewStroke);
}

export function fill(
  drawing: Drawing,
  idxs = all,
  isNewStroke = true
): Drawing {
  idxs = idxs.filter((idx) => !drawing.pixels[idx]);
  return flip(drawing, idxs, isNewStroke);
}

export function flood(
  drawing: Drawing,
  idx: number,
  isNewStroke = true
): Drawing {
  const idxs = Object.keys(floodPath(drawing, idx)).map((key) => parseInt(key));
  return flip(drawing, idxs, isNewStroke);
}

export function undo(drawing: Drawing): Drawing {
  return !drawing.canUndo
    ? drawing
    : new Drawing({
        id: drawing.id,
        pixels: nextPixelState(drawing, drawing.strokes[drawing.currStroke]),
        strokes: [...drawing.strokes],
        currStroke: drawing.currStroke - 1,
      });
}

export function redo(drawing: Drawing): Drawing {
  return !drawing.canRedo
    ? drawing
    : new Drawing({
        id: drawing.id,
        pixels: nextPixelState(
          drawing,
          drawing.strokes[drawing.currStroke + 1]
        ),
        strokes: [...drawing.strokes],
        currStroke: drawing.currStroke + 1,
      });
}

function nextPixelState(drawing: Drawing, idxs: number[]): Pixels {
  const next = Object.assign({}, drawing.pixels);
  for (const idx of idxs) {
    drawing.pixels[idx] ? delete next[idx] : (next[idx] = true);
  }
  return next;
}
